import axiosInstance from "../axiosInstance";

import type { ReportListParams, ReportListResponse, ReportDetailResponse, UpdateReportStatusRequest, ResolveTargetRequest } from "../types/report.types";

const BASE = "/community/api/v1/admin/reports";

export const reportsService = {
  list: (params?: ReportListParams) => axiosInstance.get<ReportListResponse>(BASE, { params }),

  get: (id: number) => axiosInstance.get<ReportDetailResponse>(`${BASE}/${id}`),

  updateStatus: (id: number, payload: UpdateReportStatusRequest) => axiosInstance.patch<ReportDetailResponse>(`${BASE}/${id}/status`, payload),

  resolveTarget: (payload: ResolveTargetRequest) => axiosInstance.post<{ success: boolean; data: { resolved_count: number } }>(`${BASE}/resolve-target`, payload),
};
